import axios from 'axios';
import { store } from '../store';
import router from '../router';
const apiClientToken = axios.create();

apiClientToken.interceptors.request.use(config => {
    const token = store.getters.getUsuarioLogueado?.TokenJWT;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`; // Cifra el payload
    }
  return config;
});

apiClientToken.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        store.dispatch("setUsuarioLogueado", null);
        router.push("/login");
      }
      return Promise.reject(error);
    }
);

export default apiClientToken;
